module.exports = __webpack_public_path__ + "media/landing_page/linkedin-cashew-68bfd49a.svg";